import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { ToastError, ToastInfo, ToastSuccess } from "components/Global/Toasts/Toasty";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , subKeySaga
  , fillDictionary
  , multipleObjectReturn
} from "shared-utility/store/utils/helpers";

// ACTIONS

export const QUOTE_DETAIL_DELETE_QUOTE = generateDefaultActions("QUOTE_DETAIL_DELETE_QUOTE");
export const deleteQuote = payload => makePayload(QUOTE_DETAIL_DELETE_QUOTE.value, payload);
function* deleteQuoteSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/loans/deleteLoan/${payload.quoteId}`;
  yield requestSaga(QUOTE_DETAIL_DELETE_QUOTE, url, "DELETE");
  yield callback();
}

export const QUOTE_DETAIL_GET_QUOTE = generateDefaultActions("QUOTE_DETAIL_GET_QUOTE");
export const quoteDetailGetQuote = payload => makePayload(QUOTE_DETAIL_GET_QUOTE.value, payload);
function* quoteDetailGetQuoteSaga(payload) {
  const url = `/loans/getLoanDetails/${payload.quoteId}`;
  yield requestSaga(QUOTE_DETAIL_GET_QUOTE, url, "GET");
}

export const QUOTE_DETAIL_CLEAR_QUOTE = generateDefaultActions("QUOTE_DETAIL_CLEAR_QUOTE");
export const quoteDetailClearQuote = payload => makePayload(QUOTE_DETAIL_CLEAR_QUOTE.value, payload);
function* quoteDetailClearQuoteSaga(payload) {
  const url = `/loans/getLoanEmptyDetails/${payload.dealId}`;
  yield requestSaga(QUOTE_DETAIL_CLEAR_QUOTE, url, "GET");
}

export const QUOTE_DETAIL_DEAL_GET = generateDefaultActions("QUOTE_DETAIL_DEAL_GET");
export const dealGet = payload => makePayload(QUOTE_DETAIL_DEAL_GET.value, payload);
function* dealGetSaga(payload) {
  const url = `/deals/${payload.dealId}`;
  yield requestSaga(QUOTE_DETAIL_DEAL_GET, url, "GET");
}

export const QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY = generateDefaultActions("QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY");
export const getLoansByPreferenceAndLoanSeniority = payload => makePayload(QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.value, payload);
function* getLoansByPreferenceAndLoanSenioritySaga(payload) {
  const url = "/getLoansByPreference/bySeniority";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY, url, "POST", filteredPayload);
}

export const QUOTE_DETAIL_SAVE_ORDER_CHANGE = generateDefaultActions("QUOTE_DETAIL_SAVE_ORDER_CHANGE");
export const saveOrderChange = payload => makePayload(QUOTE_DETAIL_SAVE_ORDER_CHANGE.value, payload);
function* saveOrderChangeSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/saveQuoteOrderChange";
  yield requestSaga(QUOTE_DETAIL_SAVE_ORDER_CHANGE, url, "POST", payload);
  yield callback();
}

export const QUOTE_DETAIL_CLONE_QUOTE = generateDefaultActions("QUOTE_DETAIL_CLONE_QUOTE");
export const cloneQuote = payload => makePayload(QUOTE_DETAIL_CLONE_QUOTE.value, payload);
function* cloneQuoteSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/loan/cloneQuote";
  yield requestSaga(QUOTE_DETAIL_CLONE_QUOTE, url, "POST", payload);
  yield callback();
}

export const QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS = generateDefaultActions("QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS");
export const saveQuoteShortListAndStatus = payload => makePayload(QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS.value, payload);
function* saveQuoteShortListAndStatusSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/saveQuoteShortListAndStatus";
  yield requestSaga(QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS, url, "POST", payload);

  yield callback();
}

export const QUOTE_DETAIL_UPDATE_LOAN_DETAILS = generateDefaultActions("QUOTE_DETAIL_UPDATE_LOAN_DETAILS");
export const updateLoanDetails = payload => makePayload(QUOTE_DETAIL_UPDATE_LOAN_DETAILS.value, payload);
function* updateLoanDetailsSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/loans/updateLoanDetails/${payload.id}`;
  yield* requestSaga(QUOTE_DETAIL_UPDATE_LOAN_DETAILS, url, "POST", payload.loanDetails);
  yield callback();
}

export const QUOTE_DETAIL_REQUEST_NEW_CONTACT = generateDefaultActions("QUOTE_DETAIL_REQUEST_NEW_CONTACT");
export const requestNewContact = payload => makePayload(QUOTE_DETAIL_REQUEST_NEW_CONTACT.value, payload);
function* getRequestNewContactSaga(payload) {
  const url = "/requestNewContact";
  yield requestSaga(QUOTE_DETAIL_REQUEST_NEW_CONTACT, url, "POST", payload);
}

// START NOTES
export const QUOTE_DETAIL_GET_NOTES = generateDefaultActions("QUOTE_DETAIL_GET_NOTES");
export const loanGetNotes = payload => makePayload(QUOTE_DETAIL_GET_NOTES.value, payload);
function* loanGetNotesSaga(payload) {
  const url = `/loans/notes/${payload.quoteId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(QUOTE_DETAIL_GET_NOTES, url, "GET");
}

export const QUOTE_DETAIL_PUT_NOTE = generateDefaultActions("QUOTE_DETAIL_PUT_NOTE");
export const loanPutNote = payload => makePayload(QUOTE_DETAIL_PUT_NOTE.value, payload);
function* loanPutNoteSaga(payload) {
  const url = `/notes/${payload.note.id}`;
  yield requestSaga(QUOTE_DETAIL_PUT_NOTE, url, "PUT", payload);
  yield put(loanGetNotes({ quoteId: payload.loanId }));
}

export const QUOTE_DETAIL_POST_NOTE = generateDefaultActions("QUOTE_DETAIL_POST_NOTE");
export const loanPostNote = payload => makePayload(QUOTE_DETAIL_POST_NOTE.value, payload);
function* loanPostNoteSaga(payload) {
  const url = "/notes";
  const note = {
    model: "loan",
    modelId: payload.loanId,
    note: payload.note,
    pinned: false
  };
  yield requestSaga(QUOTE_DETAIL_POST_NOTE, url, "POST", { note });
  yield put(loanGetNotes({ quoteId: payload.loanId }));
}

export const QUOTE_DETAIL_DELETE_NOTE = generateDefaultActions("QUOTE_DETAIL_DELETE_NOTE");
export const loanDeleteNote = payload => makePayload(QUOTE_DETAIL_DELETE_NOTE.value, payload);
function* loanDeleteNoteSaga(payload) {
  const url = `/notes/${payload.noteId}`;
  yield requestSaga(QUOTE_DETAIL_DELETE_NOTE, url, "DELETE");
  yield put(loanGetNotes({ quoteId: payload.loanId }));
}
// END NOTES

// START ATTACHMENTS

export const QUOTE_DETAIL_GET_ATTACHMENTS = generateDefaultActions("QUOTE_DETAIL_GET_ATTACHMENTS");
export const loanGetAttachments = payload => makePayload(QUOTE_DETAIL_GET_ATTACHMENTS.value, payload);
function* loanGetAttachmentsSaga(payload) {
  const url = "/getFiles/byModel";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(QUOTE_DETAIL_GET_ATTACHMENTS, url, "POST", payload);
}

export const QUOTE_DETAIL_PUT_ATTACHMENT = generateDefaultActions("QUOTE_DETAIL_PUT_ATTACHMENT");
export const loanPutAttachment = payload => makePayload(QUOTE_DETAIL_PUT_ATTACHMENT.value, payload);
function* loanPutAttachmentSaga(payload) {
  const url = "/files";
  payload = {
    ...payload,
    id: payload.file.id,
    isPrivate: payload.file.isPrivate,
    model: "loan",
    modelId: payload.loanId,
    url: "/files"
  };

  yield requestSaga(QUOTE_DETAIL_PUT_ATTACHMENT, url, "PUT", payload);
  yield put(loanGetAttachments({ modelName: "loan", modelId: payload.loanId }));
}

export const QUOTE_DETAIL_POST_ATTACHMENT = generateDefaultActions("QUOTE_DETAIL_POST_ATTACHMENT");
export const loanPostAttachment = payload => makePayload(QUOTE_DETAIL_POST_ATTACHMENT.value, payload);
function* loanPostAttachmentSaga(payload) {
  const callback = handleCallback(payload);
  payload = {
    ...payload,
    model: "loan",
    modelId: payload.loanId,
    url: "/files"
  };

  yield call(uploadFile, payload);
  yield put(QUOTE_DETAIL_POST_ATTACHMENT.createSuccess());
  yield put(loanGetAttachments({ modelName: "loan", modelId: payload.loanId }));
  yield callback();
}

export const QUOTE_DETAIL_DELETE_ATTACHMENT = generateDefaultActions("QUOTE_DETAIL_DELETE_ATTACHMENT");
export const loanDeleteAttachment = payload => makePayload(QUOTE_DETAIL_DELETE_ATTACHMENT.value, payload);
function* loanDeleteAttachmentSaga(payload) {
  const url = `/files/${payload.fileId}`;
  const callback = handleCallback(payload);

  yield requestSaga(QUOTE_DETAIL_DELETE_ATTACHMENT, url, "DELETE", payload);
  yield put(loanGetAttachments({ modelName: "loan", modelId: payload.loanId }));
  yield callback();
}

// END ATTACHMENTS

// REDUCER

const initialState = {
  quote: {}
};

export function quoteDetailReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case QUOTE_DETAIL_GET_QUOTE.success:
    case QUOTE_DETAIL_CLEAR_QUOTE.success:
      return multipleObjectReturn(state, ["quote", "guestPermission"], [payload.data, payload.guestPermission]);

    case QUOTE_DETAIL_DELETE_QUOTE.success:
      return defaultReturn(state, {}, "quote");

    case QUOTE_DETAIL_UPDATE_LOAN_DETAILS.success:
      ToastSuccess("Update complete");

      return defaultReturn(state, payload, "quoteId");

    case QUOTE_DETAIL_UPDATE_LOAN_DETAILS.failure:
      ToastError("Update failed. Please ensure valid inputs.");

      return defaultReturn(state);

    case QUOTE_DETAIL_CLONE_QUOTE.failure:
      ToastError("Clone failed.");

      return defaultReturn(state);

    case QUOTE_DETAIL_DEAL_GET.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case QUOTE_DETAIL_DEAL_GET.success:
      return multipleObjectReturn(state, ["deal", "guestPermission"], [payload.deal, payload.guestPermission]);

    case QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.success:
      return fillDictionary(state, payload, "quotesByPreference", subKey);

    case QUOTE_DETAIL_SAVE_ORDER_CHANGE.success:
      ToastSuccess("Order updated");

      return defaultReturn(state);

    case QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS.success:
      ToastSuccess("Saved");

      return defaultReturn(state);

    case QUOTE_DETAIL_REQUEST_NEW_CONTACT.success:
      ToastSuccess("Request Created");

      return defaultReturn(state);

      // ATTACHMENTS
    case QUOTE_DETAIL_GET_ATTACHMENTS.success:
      return defaultReturn(state, payload.data, "attachments");

    case QUOTE_DETAIL_PUT_ATTACHMENT.success:
      ToastSuccess("File Successfully Updated");

      return defaultReturn(state);

    case QUOTE_DETAIL_POST_ATTACHMENT.success:
      ToastSuccess("File Successfully Added");

      return defaultReturn(state);

    case QUOTE_DETAIL_DELETE_ATTACHMENT.success:
      ToastSuccess("File Successfully Deleted");

      return defaultReturn(state);

    // NOTES
    case QUOTE_DETAIL_GET_NOTES.success:
      return defaultReturn(state, payload.data, "notes");

    case QUOTE_DETAIL_POST_NOTE.success:
      ToastSuccess("Note Successfully Added");

      return defaultReturn(state);

    case QUOTE_DETAIL_PUT_NOTE.success:
      ToastSuccess("Note Successfully Updated");

      return defaultReturn(state);

    case QUOTE_DETAIL_DELETE_NOTE.success:
      ToastSuccess("Note Successfully Deleted");

      return defaultReturn(state);

    default:
      return defaultReturn(state);
  }
}

// SAGA

export function* quoteDetailSaga() {
  yield takeLatest(QUOTE_DETAIL_DEAL_GET.value, dealGetSaga);
  yield takeLatest(QUOTE_DETAIL_UPDATE_LOAN_DETAILS.value, updateLoanDetailsSaga);
  yield takeLatest(QUOTE_DETAIL_GET_QUOTE.value, quoteDetailGetQuoteSaga);
  yield takeLatest(QUOTE_DETAIL_CLEAR_QUOTE.value, quoteDetailClearQuoteSaga);
  yield takeEvery(QUOTE_DETAIL_GET_LOANS_BY_PREFERENCE_AND_LOAN_SENIORITY.value, getLoansByPreferenceAndLoanSenioritySaga);
  yield takeLatest(QUOTE_DETAIL_SAVE_ORDER_CHANGE.value, saveOrderChangeSaga);
  yield takeLatest(QUOTE_DETAIL_SAVE_QUOTE_SHORT_LIST_AND_STATUS.value, saveQuoteShortListAndStatusSaga);
  yield takeLatest(QUOTE_DETAIL_REQUEST_NEW_CONTACT.value, getRequestNewContactSaga);
  yield takeLatest(QUOTE_DETAIL_DELETE_QUOTE.value, deleteQuoteSaga);
  yield takeLatest(QUOTE_DETAIL_CLONE_QUOTE.value, cloneQuoteSaga);
  yield takeLatest(QUOTE_DETAIL_GET_ATTACHMENTS.value, loanGetAttachmentsSaga);
  yield takeLatest(QUOTE_DETAIL_PUT_ATTACHMENT.value, loanPutAttachmentSaga);
  yield takeLatest(QUOTE_DETAIL_POST_ATTACHMENT.value, loanPostAttachmentSaga);
  yield takeLatest(QUOTE_DETAIL_DELETE_ATTACHMENT.value, loanDeleteAttachmentSaga);
  yield takeLatest(QUOTE_DETAIL_GET_NOTES.value, loanGetNotesSaga);
  yield takeLatest(QUOTE_DETAIL_PUT_NOTE.value, loanPutNoteSaga);
  yield takeLatest(QUOTE_DETAIL_POST_NOTE.value, loanPostNoteSaga);
  yield takeLatest(QUOTE_DETAIL_DELETE_NOTE.value, loanDeleteNoteSaga);
}
